import { render, staticRenderFns } from "./ShippingCarriersForm.vue?vue&type=template&id=7904b6ea"
import script from "./ShippingCarriersForm.vue?vue&type=script&lang=js"
export * from "./ShippingCarriersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports